import { LoaderCircle, Mic, Square } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

export const MicButton = ({ onText, testid = "mic-btn", label = "Dicter" }) => {
  const [state, setState] = useState("idle");
  const recorder = useRef(null);
  useEffect(() => () => recorder.current?.state === "recording" && recorder.current.stop(), []);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const rec = new MediaRecorder(stream);
      const chunks = [];
      rec.ondataavailable = (e) => chunks.push(e.data);
      rec.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunks, { type: rec.mimeType || "audio/webm" });
        if (blob.size < 1000) { setState("idle"); return; }
        setState("busy");
        try {
          const form = new FormData();
          form.append("audio", blob, "dictee.webm");
          const { data } = await api.post("/ai/transcribe", form);
          if (data.text) onText(data.text.trim());
        } catch (e) { toast.error(e?.response?.data?.detail || "Transcription impossible."); } finally { setState("idle"); }
      };
      rec.start();
      recorder.current = rec;
      setState("rec");
    } catch { toast.error("Accès au micro refusé par le navigateur."); }
  };

  return (
    <button type="button" className={`mic-btn${state === "rec" ? " is-rec" : ""}`} disabled={state === "busy"} onClick={() => (state === "rec" ? recorder.current.stop() : start())} title={state === "rec" ? "Arrêter la dictée" : label} data-testid={testid}>
      {state === "busy" ? <LoaderCircle size={14} className="spin" /> : state === "rec" ? <Square size={13} /> : <Mic size={14} />}
      <span>{state === "busy" ? "Transcription…" : state === "rec" ? "Arrêter" : label}</span>
    </button>
  );
};
